import { Alert, Autocomplete, Box, Button, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";

const AddReportPage = () =>
{
    const navigate = useNavigate();

    const [product, setProduct] = useState( '');
    const [searchedProducts, setSearchedProducts] = useState( []);
    const [duration, setDuration] = useState( 0);
    const [temperature, setTemperature] = useState( 0);
    const [crispyness, setCrispyness] = useState( '');
    const [innerCrispyness, setInnerCrispyness] = useState( '')
    const [errorMessage, setErrorMessage] = useState(null);
    const [crispynessValues, setCrispynessValues] = useState([]);

    useEffect(() => {
        getProducts();
        getCrispynessValues();
    }, []);

    const handleSubmit = async () => {
        const myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');

        const requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify({
                'product': product?.id,
                'duration': duration,
                'temperature': temperature,
                'crispyness': crispyness,
                'innerCrispyness': innerCrispyness
            })
        };
        const response = await fetch('/api/report', requestOptions);
        if(response.ok){
            navigate('/report', {state: {message: 'Der Erfahrungsbericht wurde erfolgreich hinzugefügt.'}});
        }else{
            const json = await response.json();
            setErrorMessage(json.message);
            setTimeout(() => setErrorMessage(null), 3000);
        }
    };

    const getCrispynessValues = () => {
        const requestOptions = {
            method: 'GET'
        };
        
        fetch('/api/crispyness', requestOptions)
        .then(r => r.json())
        .then(res => {
            setCrispynessValues(res)
        })
        .catch(err => {
            console.error(err);
        })
    };

    const getProducts = () => {
        const requestOptions = {
            method: 'GET'
        };
        
        fetch('/api/public/products?searchTerm=', requestOptions)
        .then(r => r.json())
        .then(res => {
            let products = [];
            res.forEach((product) => {
                products.push({id: product?.id, label: product?.name});
            })
            setSearchedProducts(products);
        })
        .catch(err => console.error(err));
    }

    return(
        <Box sx={{flexGrow: 1, maxWidth: {xs: 'calc(100% - 26px)', md: 'auto'}}} className="centered">
            <Button sx={{marginLeft:'15px !important', marginTop: '20px !important'}} fullWidth className="custom-button-root" onClick={evt => window.location.assign('/report')}>zurück</Button> 
            <h2>Erfahrungsbericht hinzufügen</h2>
            <Autocomplete
                fullWidth
                disablePortal
                options={searchedProducts}
                onChange={(event, newValue) => {
                    setProduct(newValue);
                }}
                renderInput={(params) => <TextField {...params} required label="Produkt" />}
            />
            <TextField
               fullWidth
               label="Temperatur (°C)"
               required
               type="number"
               onChange={(event) => setTemperature(event.target.value)}
            />
            <TextField
                fullWidth
               label="Dauer (min)"
               required
               type="number"
               onChange={(event) => setDuration(event.target.value)}
            />
            <FormControl fullWidth>
                <InputLabel required id='input-cross-label' >Krossheits-Level</InputLabel>
                <Select
                labelId='input-cross-label'
                id='input-cross'
                label="Krossheits-Level"
                value={crispyness}
                onChange={(event) => setCrispyness(event.target.value)}>
                    {crispynessValues?.map(cris => (
                        <MenuItem value={cris?.name} key={cris?.name}>{cris?.label}</MenuItem>)
                    )}
                </Select>
            </FormControl>
            <FormControl fullWidth>
                <InputLabel required id="input-inner-crossheit-label">Krossheits-Level innen</InputLabel>
                <Select
                labelId="input-inner-crossheit-label"
                label="Krossheits-Level innen"
                value={innerCrispyness}
                onChange={(event) => setInnerCrispyness(event.target.value)}>
                    {crispynessValues?.map(cris => (
                        <MenuItem value={cris?.name} key={cris?.name}>{cris?.label}</MenuItem>)
                    )}
                </Select>
            </FormControl>
            <Button sx={{marginLeft:'15px !important'}} fullWidth className="custom-button-root" onClick={() => handleSubmit()}>Erfahrungsbericht erstellen</Button>
            {errorMessage && <Alert severity="error">{errorMessage}</Alert>}
        </Box>
    );
}

export default AddReportPage;